<div class="page center">
  <div class="login-card" (keyup.enter)="login()">
        <div style="float: right;" class="eyebrow">VisitoCare</div>

        <div style="margin-top: 1cm; margin-bottom: 1cm;">
          <h2>Secure login</h2>
        </div>
    <label>Email</label><input [(ngModel)]="email" placeholder="your email here">
    <label style="margin-top:20px">Password</label><input [(ngModel)]="password" type="password" placeholder="your password here">
    <button (click)="login()"  style="margin-top:20px">Login</button>
      
      <div  style="float: right;" class="error" *ngIf="error">{{ error }}</div>
      <div style="margin-top: 20px;">
        <div class="small" style="margin-top:12px">No account yet? <a class="link" routerLink="/signup">Sign up</a></div>
        <div class="small" style="margin-top:12px;">
          <a class="link" routerLink="/forgot-password">Forgot password?</a>
        </div>
      </div>
  </div>
  
</div>
